import { AllRfqThemeModeConfig } from './types';

const dark: AllRfqThemeModeConfig = {
  allRfq: {},
};

export default dark;
